/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { Section } from 'templates/pubSub/types/TemplateType';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import SectionRowContent from './SectionRowContent';
import SectionRowPlaceholder from './SectionRowPlaceholder';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import RenderOnCondition from './RenderOnCondition';

interface ISectionContentProps {
  templateContext: TemplateContext;
  section: Section;
  cols: string;
  startingNodeId?: NodeIdentifier;
}

export default function SectionContent(props: ISectionContentProps): ReactElement {
  return (
    <>
      {props.section.rows.map((row, rowIndex) => (
        <RenderOnCondition
          key={TemplateHelperPubSub.getPlaceholderKey(row.id, rowIndex)}
          templateContext={props.templateContext}
          condition={row.condition}
          startingNodeId={props.startingNodeId}
        >
          {!row.placeholders || row.placeholders.length === 0 ? (
            <SectionRowContent
              templateContext={props.templateContext}
              row={row}
              startingNodeId={props.startingNodeId}
              cols={props.cols}
              key={TemplateHelperPubSub.getPlaceholderKey(row.id, rowIndex)}
            />
          ) : (
            <SectionRowPlaceholder
              key={TemplateHelperPubSub.getPlaceholderKey(row.id, rowIndex)}
              templateContext={props.templateContext}
              row={row}
              placeholder={row.placeholders[0]}
              placeholderIndex={0}
              startingNodeId={props.startingNodeId}
              cols={props.cols}
            />
          )}
        </RenderOnCondition>
      ))}
    </>
  );
}
